import { render, staticRenderFns } from "./ConsultaOrdenView.vue?vue&type=template&id=4bb291a8&scoped=true"
import script from "./ConsultaOrdenView.vue?vue&type=script&lang=js"
export * from "./ConsultaOrdenView.vue?vue&type=script&lang=js"
import style0 from "./ConsultaOrdenView.vue?vue&type=style&index=0&id=4bb291a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb291a8",
  null
  
)

export default component.exports